module.exports = __webpack_public_path__ + "img/IEBKIREL.05c00940.png";